import React from 'react';
import { motion } from 'framer-motion';
import './AboutUsStory.css';

const AboutUsStory: React.FC = () => {

  return (
    <motion.section
      className="about-story"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="about-story-container">
        <div className="about-story-header">
          <h2 className="about-story-title">Our <span className="highlight">Journey</span></h2>
          <p className="about-story-subtitle">From innovation to industry leadership</p>
        </div>

        <div className="about-story-timeline">
          <div className="about-timeline-item">
            <div className="about-timeline-marker"></div>
            <div className="about-timeline-content">
              <h3 className="about-timeline-year">Q2 2025</h3>
              <h4 className="about-timeline-title">Strategic Foundation</h4>
              <p className="about-timeline-text">
                Cinquity was founded by a team of clinical research veterans and AI technology experts, combining decades of industry experience with cutting-edge innovation to address critical gaps in eCOA solutions.
              </p>
            </div>
          </div>

          <div className="about-timeline-item">
            <div className="about-timeline-marker"></div>
            <div className="about-timeline-content">
              <h3 className="about-timeline-year">Q3 2025</h3>
              <h4 className="about-timeline-title">Platform Development</h4>
              <p className="about-timeline-text">
                Developed our proprietary AI-powered eCOA platform with advanced features including intelligent assessment creation, real-time data validation, and seamless patient engagement tools.
              </p>
            </div>
          </div>

          <div className="about-timeline-item">
            <div className="about-timeline-marker"></div>
            <div className="about-timeline-content">
              <h3 className="about-timeline-year">Q4 2025</h3>
              <h4 className="about-timeline-title">Validation & Testing</h4>
              <p className="about-timeline-text">
                Completed comprehensive platform validation and pilot testing with industry experts, demonstrating our platform's potential to reduce protocol deviations by 30% and accelerate trial timelines by 25%.
              </p>
            </div>
          </div>

          <div className="about-timeline-item">
            <div className="about-timeline-marker"></div>
            <div className="about-timeline-content">
              <h3 className="about-timeline-year">Q1 2026</h3>
              <h4 className="about-timeline-title">Market Launch</h4>
              <p className="about-timeline-text">
                Preparing for market entry with select pharmaceutical partners, backed by proven technology and a team of clinical research experts ready to transform how clinical trials are conducted.
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default AboutUsStory;
